import { Skeleton, Stack } from "@mui/material";
import { useGetMerchantQuery } from "Api/Queries/Merchants/useGetMerchantQuery";
import { AmlMerchantDetailPageContent } from "Components/Hunter/Merchants/Detail/AmlMerchantDetailPageContent";
import { MerchantDetailPageContent } from "Components/Hunter/Merchants/Detail/MerchantDetailPageContent";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useIsCurrentUserAML } from "Hooks/useIsCurrentUserAml";
import { Resources, useResource } from "Translations/Resources";
import { getAppUrl } from "Utils/UrlUtils";
import type { ReactNode } from "react";
import { useParams } from "react-router-dom";

export const MerchantDetailPage = () => {
  const { publicID } = useParams();
  const { t } = useResource();
  const isAml = useIsCurrentUserAML();
  const { data, isLoading, isError } = useGetMerchantQuery(
    publicID,
    !!publicID,
  );

  if (isLoading) {
    return (
      <Layout>
        <Stack gap={2}>
          <Skeleton height={48} variant="rounded" />
          <Skeleton height={524} variant="rounded" />
        </Stack>
      </Layout>
    );
  }

  if (isError || !publicID || !data || !data?.party) {
    return (
      <Layout>
        <ErrorText>{t(Resources.Error.MerchantNotSelected)}</ErrorText>
      </Layout>
    );
  }

  const DetailContent = isAml
    ? AmlMerchantDetailPageContent
    : MerchantDetailPageContent;

  return (
    <Layout title={data.party.companyName || undefined}>
      <DetailContent
        publicPartyID={data.party.publicID || ""}
        merchantPublicID={publicID}
      />
    </Layout>
  );
};

export default MerchantDetailPage;

type LayoutProps = { children: ReactNode; title?: string };

const Layout = ({ children, title }: LayoutProps) => {
  const appUrl = getAppUrl();

  return (
    <AuthenticatedLayout
      title={title || ""}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("merchants"),
      }}
    >
      <StyledPageWrapper>
        <div className="left-content">{children}</div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
